<template>
  <div class="d-flex align-center">
    <template v-if="$config.isWeb">
      <v-text-field
        v-model="mHour"
        label="hh"
        :rules="mRules.mHour"
      />
      <div class="mx-2">
        :
      </div>
      <v-text-field
        v-model="mMin"
        label="mm"
        :rules="mRules.mMin"
      />
    </template>
    <template v-else>
      <v-dialog
        ref="dialog"
        v-model="dialog"
        :return-value.sync="mTime"
        full-width
        width="290px"
      >
        <template v-slot:activator="{ on }">
          <v-text-field
            v-model="mTime"
            :label="label"
            readonly
            v-on="on"
          />
        </template>
        <v-time-picker
          v-if="dialog"
          v-model="mTime"
          full-width
        >
          <div class="flex-grow-1" />
          <v-btn
            text
            color="primary"
            @click="dialog = false"
          >
            Cancel
          </v-btn>
          <v-btn
            text
            color="primary"
            @click="$refs.dialog.save(mTime)"
          >
            OK
          </v-btn>
        </v-time-picker>
      </v-dialog>
    </template>
  </div>
</template>

<script>

import VuetifyJetValidatorPlus from '@/plugins/vuetifyJetValidatorPlus'

function toTime () {
  if (this.mHour && this.mMin) {
    this.mTime = `${this.mHour}:${this.mMin}`
  }
}

export default {
  props: {
    label: {
      type: String,
      default: 'hh:mm'
    },
    value: {
      type: String, // hh:hh
      default: null
    },
    rules: {
      type: Array,
      default: function () {
        return []
      }
    }
  },
  data () {
    const validator = new VuetifyJetValidatorPlus()
    return {
      dialog: false,
      mTime: this.value,
      mHour: null,
      mMin: null,
      mRules: {
        mHour: [
          validator.rules.numberBetween(0, 24, 'Valid hour')
        ],
        mMin: [
          validator.rules.numberBetween(0, 60, 'Valid Min')
        ]
      }
    }
  },
  watch: {
    value: {
      handler: function (val) {
        if (val !== null) {
          let tTime = val.split(':')
          this.mHour = tTime[0]
          this.mMin = tTime[1]
        }
      },
      immediate: true
    },
    mHour: toTime,
    mMin: toTime,
    mTime: function (val) {
      this.$emit('input', val)
    }
  },
  created () {
    // this.debounceChangeDate = _.debounce(this.changeDate, 300)
  },
  mounted () {
    // if (this.showLeave) {
    //   this.leaves = this.simplePubHolidays
    // }
  }
}
</script>
